<template>
  <div>
    <top-navbar></top-navbar>
    <div class="background_color mb-5">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Assets
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/cmmsassets/index">Manage Assets</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Transfer Assets
      </h6>

      <div class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
            <form v-else @submit.prevent="saveTransfer">
              <div class="row">
                <div class="col-md-3">
                  <label class="custom-label">Asset Code <span class="text-danger">*</span></label>
                  <v-select class="font-size_def" label="label" v-model="form.asset" :options="assets" placeholder="Select Asset"></v-select>
                </div>
                <div class="col-md-3">
                  <label class="custom-label">Asset Name</label>
                  <input class="form-control form-control-sm bdr-rad" :value="form.asset ? form.asset.asset_name : ''" readonly>
                </div>
                <div class="col-md-3">
                  <label class="custom-label">Current Location</label>
                  <input class="form-control form-control-sm bdr-rad" :value="form.asset ? form.asset.location : ''" readonly>
                </div>
                <div class="col-md-3">
                  <label class="custom-label">Current Department</label>
                  <input class="form-control form-control-sm bdr-rad" :value="form.asset ? form.asset.department : ''" readonly>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-3">
                  <label class="custom-label">Transfer Location <span class="text-danger">*</span></label>
                  <v-select class="font-size_def" label="label" v-model="form.location" :options="locations" placeholder="Select Location"></v-select>
                </div>
                <div class="col-md-3">
                  <label class="custom-label">Transfer Department <span class="text-danger">*</span></label>
                  <v-select class="font-size_def" label="label" v-model="form.department" :options="departments" placeholder="Select Department"></v-select>
                </div>
                <div class="col-md-3">
                  <label class="custom-label">Transfer Date <span class="text-danger">*</span></label>
                  <input type="date" v-model="form.transfer_date" class="form-control form-control-sm bdr-rad" required>
                </div>
                <div class="col-md-3">
                  <label class="custom-label">Remarks</label>
                  <input v-model="form.remarks" class="form-control form-control-sm bdr-rad">
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <button type="button" @click="$router.push('/cmmsassets/index')" class="btn btn-outline-primary btn-sm bdr-rad me-2">Back</button>
                <button type="submit" class="btn btn-outline-primary btn-sm bdr-rad">Transfer</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter, 'v-select': vSelect },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      isLoading: true,
      assets: [],
      locations: [],
      departments: [],
      form: { asset: null, location: null, department: null, transfer_date: new Date().toISOString().slice(0, 10), remarks: '' },
    };
  },
  mounted() {
    this.loadTransferData();
  },
  methods: {
    async loadTransferData() {
      try {
        const { data } = await axios.get('/ciinventory/transferdata', { headers: { Authorization: 'Bearer ' + this.access_token } });
        this.assets = data.assets || [];
        this.locations = data.locs || [];
        this.departments = data.deps || [];
      } catch (error) {
        console.log(error.response);
      } finally {
        this.isLoading = false;
      }
    },
    async saveTransfer() {
      if (!this.form.asset || !this.form.location || !this.form.department) {
        this.$bvToast.toast('Asset, destination location and destination department are required.', { title: 'Validation', variant: 'warning', solid: true });
        return;
      }
      try {
        const { data } = await axios.post('/ciinventory/assettransfer', {
          transfer: {
            asset_id: this.form.asset.value,
            location_id: this.form.location.value,
            department_id: this.form.department.value,
            transfer_date: this.form.transfer_date,
            remarks: this.form.remarks,
          },
        }, { headers: { Authorization: 'Bearer ' + this.access_token } });
        if (data.status !== 200) throw new Error(data.message || 'Asset transfer failed.');
        this.$bvToast.toast(data.message, { title: 'Success', variant: 'success', solid: true });
        this.$router.push('/cmmsassets/index');
      } catch (error) {
        this.$bvToast.toast(error.response && error.response.data ? error.response.data.message : error.message, { title: 'Error', variant: 'danger', solid: true });
      }
    },
  },
};
</script>
